module.exports = __webpack_public_path__ + "static/media/1_A1_14.e9bc5e4b.png";